import React, { useState, useEffect, memo } from 'react';
import './PostOptionModal.css';
import iconCopyLink from '../../../../assets/icons/icon_copy_link.svg';
import iconDelete from '../../../../assets/icons/icon_delete_red.svg';
import VIToast from '../../../common/VIToast/VIToast';

interface PostOptionModalProps {
  onClose: () => void;
  onCopyLink: () => void;
  onDeletePost: () => void;
  postId: number;
  slug: string;
}

const PostOptionModal: React.FC<PostOptionModalProps> = ({ onClose, onCopyLink, onDeletePost, postId, slug }) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    console.log('PostOptionModal mounted for post:', postId);
    return () => {
      console.log('PostOptionModal unmounted for post:', postId);
    };
  }, [postId]);

  const handleCopyLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('Copy link button clicked for post:', postId);
    onCopyLink();
    navigator.clipboard.writeText(`${window.location.origin}/posts/${slug}`)
      .then(() => {
        setShowToast(true);
        setTimeout(() => {
          onClose();
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy link:', err);
      });
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('handleDeleteClick called in PostOptionModal for post:', postId);
    setShowDeleteConfirmation(true);
  };

  const handleConfirmDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('handleConfirmDelete called in PostOptionModal for post:', postId);
    onDeletePost();
  };

  const handleCancelDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('handleCancelDelete called in PostOptionModal for post:', postId);
    setShowDeleteConfirmation(false);
  };

  console.log('Rendering PostOptionModal for post:', postId, 'showDeleteConfirmation:', showDeleteConfirmation);

  return (
    <div className="post-option-modal-overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="post-option-modal" onClick={(e) => { e.stopPropagation(); console.log('Modal clicked for post:', postId); }}>
        {!showDeleteConfirmation ? (
          <>
            <button 
              className="modal-option" 
              onClick={handleCopyLinkClick}
            >
              <img src={iconCopyLink} alt="Copy link" className="icon" /> Copy link
            </button>
            <button 
              className="modal-option delete" 
              onClick={(e) => {
                e.stopPropagation();
                console.log('Delete button clicked for post:', postId);
                setShowDeleteConfirmation(true);
              }}
            >
              <img src={iconDelete} alt="Delete" className="icon" /> Delete
            </button>
          </>
        ) : (
          <div className="delete-confirmation">
            <h3>Delete post?</h3>
            <p>If you delete this post, you won't be able to restore it.</p>
            <button 
              className="confirm-delete" 
              onClick={(e) => {
                e.stopPropagation();
                console.log('Confirm delete clicked for post:', postId);
                onDeletePost();
              }}
            >
              Delete
            </button>
            <button 
              className="cancel-delete" 
              onClick={(e) => {
                e.stopPropagation();
                console.log('Cancel delete clicked for post:', postId);
                setShowDeleteConfirmation(false);
              }}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
      {showToast && (
        <VIToast 
          message="Post's link has been copied!" 
          onClose={() => setShowToast(false)} 
        />
      )}
    </div>
  );
};

export default memo(PostOptionModal);
